import api from '@/utils/api'

export default {
    getPlayers(page, size) {
        let range = 'range=' + encodeURIComponent(`[${page - 1},${size}]`)
        let query = 'filter=' + encodeURIComponent('{"active": true }')
        let sort = '&sort=' + encodeURIComponent('[name, ASC]')
        return api.get(`players?` + (page ? range : '') + query + sort)
    },
    getFilteredPlayers(filters, page, size, sortingOptions) {
        let query = (filters ? filters + '&range=' : '?range=') + encodeURIComponent(`[${page - 1},${size}]`)
        if (sortingOptions && sortingOptions.sortBy) {
            query += `&sort=${encodeURIComponent(`[${sortingOptions.sortBy}, ${sortingOptions.sortDesc}]`)}`
        } else {
            query += '&sort=' + encodeURIComponent('[name, ASC]')
        }
        return api.get(`players` + query)
    },
    getPlayer(id) {
        return api.get(`players/${id}`)
    },

    createPlayer(data) {
        return api.post('players', data)
    },

    updatePlayer(id, data) {
        return api.put(`players/${id}`, data)
    },

    uploadFile(formData) {
        return api.uploadFile('uploads/player', formData)
    },

    deletePlayer(id) {
        return api.delete(`players/${id}`)
    },

    setAlternativeJerseyOnPlayer(id, jersey) {
        return api.post(`players/${id}/alternative-jersey/${jersey}`, {})
    },

    resetDoctorChecks() {
        return api.post(`players/reset-doctor`, {})
    },

    uploadPlayersCSV(formData) {
        return api.uploadFile('players/import', formData)
    },

    downloadPlayersCSV(filters) {
        if (!filters) {
            filters = ''
        }
        return api.get(`players/export` + filters)
    }
}
